import React from "react";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { formatIsoDateForDisplay } from "@helpers/date";

interface Props {
    show: boolean;
    sourceAccountName: string;
    targetAccountName: string;
    lockDate: string;
    onConfirm: () => Promise<void>;
    onHide: () => void;
}

export const MergeUnlockedPeriodsInsteadModal: React.FC<Props> = ({
    show,
    sourceAccountName,
    targetAccountName,
    lockDate,
    onConfirm,
    onHide,
}) => (
    <ConfirmationModal
        show={show}
        onHide={onHide}
        title="Merge unlocked periods only"
        question={
            <p className="mb-0">
                Books are locked on or before{" "}
                <strong className="font-weight-medium">
                    {formatIsoDateForDisplay(lockDate)}
                </strong>{" "}
                and{" "}
                <strong className="font-weight-medium">
                    {sourceAccountName}
                </strong>{" "}
                has activity in that period. Entries dated on or before the lock
                date stay on{" "}
                <strong className="font-weight-medium">
                    {sourceAccountName}
                </strong>
                , everything later moves to{" "}
                <strong className="font-weight-medium">
                    {targetAccountName}
                </strong>
                , and{" "}
                <strong className="font-weight-medium">
                    {sourceAccountName}
                </strong>{" "}
                is archived rather than removed, so closed-period reports keep
                showing it.
            </p>
        }
        yes="Merge unlocked periods"
        no="Cancel"
        onConfirm={onConfirm}
        onReject={onHide}
    />
);
